import Vue from "vue";
import VueRouter from "vue-router";
const LOGGED_IN_KEY = "loggedIn";
const AVOID_NAVIGATION = "avoidNavigation";
const PASSWORD_EXPIRED = "passwordExpired";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home",
    alias: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "Home" */ "../views/Home.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "Login" */ "../views/Login.vue")
  },
  {
    path: "/registro",
    name: "Register",
    component: () =>
      import(/* webpackChunkName: "Register" */ "../views/Register.vue")
  },
  {
    path: "/productores",
    name: "Producer",
    component: () =>
      import(/* webpackChunkName: "Producer" */ "../views/Producer.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/comerciales",
    name: "CommercialPerson",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "CommercialPerson" */ "../views/CommercialPerson.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/usuarios",
    name: "CommercialPersonAlias",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "CommercialPersonAlias" */ "../views/CommercialPersonAlias.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/relevamientos",
    name: "Survey",
    component: () =>
      import(/* webpackChunkName: "Survey" */ "../views/Survey.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/estimaciones_columnas",
    name: "EstimationColumn",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "EstimationColumn" */ "../views/EstimationColumn.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/estimaciones",
    name: "Estimation",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "Estimation" */ "../views/Estimation.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/reporte_ventas",
    name: "SalesReport",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "SalesReport" */ "../views/SalesReport.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/downloads",
    name: "Downloads",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "Downloads" */ "../views/Downloads.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/client_current_account",
    name: "ClientCurrentAccount",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "ClientCurrentAccount" */ "../views/ClientCurrentAccount.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/client_current_account_movements/:days_from?/:unseen_only?",
    name: "ClientCurrentAccountMovements",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "ClientCurrentAccountMovements" */ "../views/ClientCurrentAccountMovements.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/sale_commission",
    name: "SaleCommission",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "SaleCommission" */ "../views/SaleCommission.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/kpi_ventas",
    name: "SalesKPI",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "SalesKPI" */ "../views/SalesKPI.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/tablero_ventas",
    name: "SalesDashboard",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "SalesDashboard" */ "../views/SalesDashboard.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/evolucion_ventas",
    name: "SalesEvolution",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "SalesEvolution" */ "../views/SalesEvolution.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/pedidos",
    name: "Order",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "Order" */ "../views/Order.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/settings",
    name: "Setting",
    component: () =>
      import(/* webpackChunkName: "Setting" */ "../views/Setting.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/comunicaciones",
    name: "Comunication",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "Comunication" */ "../views/Comunication.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/visor_comunicaciones",
    name: "comunicationViewer",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "ComunicationViewer" */ "../views/ComunicationViewer.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/solicitudes_de_liquidacion",
    name: "SettlementRequest",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "SettlementRequest" */ "../views/SettlementRequest.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/mercaderia_en_consignacion",
    name: "ConsignmentReport",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "ConsignmentReport" */ "../views/ConsignmentReport.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/inspecciones_lotes",
    name: "LotInspectionReport",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "LotInspectionReport" */ "../views/LotInspectionReport.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/reset/*",
    redirect: to => {
      return {
        name: "Register",
        params: {
          mode: "changePassword",
          uid: to.fullPath.split("/")[2],
          token: to.fullPath.split("/")[3]
        }
      };
    }
  },
  {
    path: "/accounts/confirm-email/*",
    redirect: to => {
      return {
        name: "Register",
        params: {
          mode: "confirmEmail",
          token: to.fullPath.split("/")[3]
        }
      };
    }
  },
  {
    path: "/404",
    alias: "*",
    name: "NotFound",
    component: () =>
      import(/* webpackChunkName: "NotFound" */ "../views/NotFound.vue")
  },
  {
    path: "/cotizaciones",
    name: "Quotation",
    component: () =>
      // eslint-disable-next-line
      import(/* webpackChunkName: "Quotation" */ "../views/Quotation.vue"),
    meta: { requiresAuth: true }
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  let isLoggedIn = eval(localStorage.getItem(LOGGED_IN_KEY));
  let avoidNavigation = eval(localStorage.getItem(AVOID_NAVIGATION));
  let passwordExpired = eval(localStorage.getItem(PASSWORD_EXPIRED));
  if (to.meta.requiresAuth && !isLoggedIn) {
    next({
      path: "/login",
      query: { redirect: to.fullPath }
    });
  } else if (
    to.name != "comunicationViewer" &&
    avoidNavigation === true &&
    !passwordExpired
  ) {
    next({
      path: "/visor_comunicaciones"
    });
  } else {
    next();
  }
});

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err)) {
      // resolve err
      return err;
    }
    // rethrow error
    return Promise.reject(err);
  });
};

export default router;
